import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ArrowUpRightIcon } from '@phosphor-icons/react';
import { cn } from '@/lib/utils';
import { appendSearchParams } from '@/utils/preserve-params';

interface InfoFieldProps {
    label: string;
    value: string | number | React.ReactNode;
    icon?: React.ComponentType<{ className?: string }>;
    link?: string;
    className?: string;
}

export function InfoField({
    label,
    value,
    icon,
    link,
    className,
}: InfoFieldProps) {
    const [searchParams] = useSearchParams();
    const displayValue = value || '-';
    const resolvedLink = link
        ? appendSearchParams(link, searchParams.toString())
        : undefined;
    const Icon = icon;

    const valueTextClassName = 'truncate text-sm font-normal text-white-100';

    const valueContent = resolvedLink ? (
        <Link
            to={resolvedLink}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex min-w-0 items-center gap-2 text-white-100 transition-colors hover:text-white-300"
        >
            <span className={valueTextClassName}>{displayValue}</span>
            <ArrowUpRightIcon className="h-4 w-4 flex-shrink-0 text-grey-300" />
        </Link>
    ) : (
        <span className={valueTextClassName}>{displayValue}</span>
    );

    return (
        <div className={cn('flex min-w-0 flex-col gap-1', className)}>
            <div className="text-sm font-normal text-grey-300 truncate">
                {label}
            </div>
            <div className="flex min-w-0 items-center gap-2">
                {Icon ? (
                    <Icon className="h-[14px] w-[14px] flex-shrink-0 text-grey-300" />
                ) : null}
                {valueContent}
            </div>
        </div>
    );
}
